import React from 'react';
import { connect } from 'react-redux';
import SaveCollectionDialog from './SaveCollectionDialog';
import CollectionDeletionDialog from './CollectionDeletionDialog';
import AssignCollectionDatasetsDialog from '../datasets/containers/AssignCollectionDatasetsDialog';
import ShareCollectionDialog from '../sharing/containers/ShareCollectionDialog';

const CollectionDialogs = ({
  allowSave,
  allowDelete,
  allowManage,
  allowShare,
  theme,
}) => (
  <>
    {allowDelete && (<CollectionDeletionDialog theme={theme} />)}
    {allowManage && (<AssignCollectionDatasetsDialog theme={theme} />)}
    {allowSave && (<SaveCollectionDialog theme={theme} />)}
    {allowShare && (<ShareCollectionDialog theme={theme} />)}
  </>
);

const mapStateToProps = ({
  auth: { role: { permissions: { collections, datasets } } },
  collections: { activeCollection, deleteCollectionOpen, sharingCollection },
  collectionDatasets: { datasetAssigningCollection },
}) => ({
  allowDelete: deleteCollectionOpen && datasets.read,
  allowManage: datasetAssigningCollection.open && datasets.read,
  allowSave: activeCollection.open && collections.create,
  allowShare: sharingCollection.open && datasets.read,
});

export default connect(mapStateToProps)(CollectionDialogs);
